import ErrorPage from './default';
import { ALREADY_PURCHASE_BAF_ERROR_PAGE_TEXT } from './constants';

function AlreadyPurchaseBaf(props) {
  return (
    <ErrorPage
      {...props}
      title={ALREADY_PURCHASE_BAF_ERROR_PAGE_TEXT.TITLE}
      iconColor="BLUE"
      iconId="informacion"
      buttonText={ALREADY_PURCHASE_BAF_ERROR_PAGE_TEXT.BUTTON_TEXT}
      buttonHref={ALREADY_PURCHASE_BAF_ERROR_PAGE_TEXT.BUTTON_HREF}
      description=""
      showLink={false}
    />
  );
}
export default AlreadyPurchaseBaf;
